var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("section", { staticClass: "home-intro-slides" }, [
    _c("h2", { staticClass: "welcome-title" }, [
      _vm._v(_vm._s(_vm.$t("homePage.introSlides.welcome"))),
    ]),
    _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "aria-label": _vm.$t("homePage.introSlides.close"),
        },
        on: { click: _vm.onCloseClick },
      },
      [_c("IconClose")],
      1
    ),
    _c(
      "div",
      { staticClass: "swiper-area" },
      [
        _c(
          "swiper",
          {
            ref: "introSwiper",
            staticClass: "swiper",
            attrs: { options: _vm.swiperOptions },
            on: { "slide-change": _vm.onSlideChange },
          },
          _vm._l(_vm.slides, function (slide, i) {
            return _c("swiper-slide", { key: i, staticClass: "slide" }, [
              _c("div", { staticClass: "slide-image-wrapper" }, [
                _c("img", {
                  staticClass: "slide-image",
                  attrs: {
                    src: slide.imageSrc,
                    alt: _vm.$t(slide.altKey),
                    draggable: "false",
                  },
                }),
              ]),
              _c("div", { staticClass: "slide-text" }, [
                _c("h3", { staticClass: "slide-title" }, [
                  _vm._v(_vm._s(_vm.$t(slide.titleKey))),
                ]),
                _c("p", { staticClass: "slide-body" }, [
                  _vm._v(_vm._s(_vm.$t(slide.bodyKey))),
                ]),
              ]),
            ])
          }),
          1
        ),
      ],
      1
    ),
    _c(
      "ol",
      { staticClass: "dots", attrs: { role: "tablist" } },
      _vm._l(_vm.slides, function (_, i) {
        return _c("li", {
          key: i,
          staticClass: "dot",
          class: { active: i === _vm.currentIndex },
          attrs: { "aria-selected": i === _vm.currentIndex, role: "tab" },
          on: {
            click: function ($event) {
              return _vm.onDotClick(i)
            },
          },
        })
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }